/**
 * pdm-benefits-menu.js
 * ------------------------------------------------------------
 * Description:
 *   Initializes the Swiper slider used in the custom
 *   "Benefits Menu" navigation bar.
 *
 *   This script enhances the benefits navigation on mobile 
 *   by enabling horizontal scrolling of menu items using Swiper.
 *
 * Behavior:
 *   - Runs only after DOM is fully loaded.
 *   - Checks if the Swiper container exists on the page.
 *   - Enables free scrolling, mousewheel support, and auto-width
 *     slides for a smooth horizontal navigation experience.
 *
 * Used in:
 *   snippets/pdm-benefits-menu.liquid
 *
 * Purpose:
 *   Provide a clean, touch-friendly, mobile navigation experience
 *   for the Benefits section of the Power Plate website.
 */

document.addEventListener('DOMContentLoaded', function () {
  const el = document.querySelector('.pdm-benefits-menu__swiper');
  if (!el) return;

  new Swiper('.pdm-benefits-menu__swiper', {
    slidesPerView: 'auto',
    spaceBetween: 2,
    freeMode: true,
    mousewheel: {
      forceToAxis: true
    }
  });
});